import RECUPERATORS from "./recuperators";
import MATERIALS_BY_VOLUME from "./materials";
import MATERIALS_BOXES from "./materialsBoxes";
import MATERIALS_COLLECTORS from "./materialsCollectors";
import MATERIALS_AIR_DUCTS from "./materialsAirDucts";
import MATERIALS_GASKETS from "./materialsGaskets";
import { fetchAndApplyPrices } from "./utils/blobStorage";

export const calculateProducts = (settingsData, roomTableData) => {
  const totalSupply = getTotal(roomTableData.rows, "supply");
  const totalExhaust = getTotal(roomTableData.rows, "exhaust");
  const materialsGroup =
    settingsData.productGroup === "premium_plus"
      ? "premium"
      : settingsData.productGroup;

  const recuperators = RECUPERATORS.filter(
    (item) =>
      totalSupply >= item.range[0] &&
      totalSupply < item.range[1] &&
      item.productGroup === settingsData.productGroup &&
      item.ventilatorType === settingsData.ventilatorType
  );

  // oro kiekis
  const materialsVolume = MATERIALS_BY_VOLUME.filter(
    (item) =>
      totalSupply >= item.range[0] &&
      totalSupply < item.range[1] &&
      item.productGroup === materialsGroup
  );

  // dezutes
  const totalSupplyBoxes = roomTableData.rows.reduce((total, row) => {
    return total + Math.ceil(row.supply / 66);
  }, 0);
  const totalExhaustBoxes = roomTableData.rows.reduce((total, row) => {
    return total + Math.ceil(row.exhaust / 66);
  }, 0);

  const materialsBoxes = MATERIALS_BOXES.filter(
    (material) => material.productGroup === materialsGroup
  ).map((material) => ({
    ...material,
    quantity: totalSupplyBoxes + totalExhaustBoxes,
  }));

  // kollektoriai
  function calculateMaterialsCollectors(volume) {
    const totalPipes = roomTableData.rows.reduce((total, row) => {
      return total + Math.ceil(row[volume] / 33);
    }, 0);

    const totalCollectorsQuantity = Math.ceil(totalPipes / 14);

    const totalPipesPerCollector =
      totalCollectorsQuantity === 0
        ? 0
        : Math.ceil(totalPipes / totalCollectorsQuantity);

    const materialsCollectors = MATERIALS_COLLECTORS.filter(
      (item) =>
        totalPipesPerCollector >= item.range[0] &&
        totalPipesPerCollector <= item.range[1] &&
        item.productGroup === materialsGroup
    ).map((item) => ({
      ...item,
      quantity: item.quantity * totalCollectorsQuantity,
    }));

    return materialsCollectors;
  }

  const materialsCollectorsSupply = calculateMaterialsCollectors("supply");
  const materialsCollectorsExhaust = calculateMaterialsCollectors("exhaust");

  const mergedMaterials = [
    ...materialsCollectorsSupply,
    ...materialsCollectorsExhaust,
  ];
  const materialsCollectors = mergedMaterials.reduce((acc, item) => {
    const existingItem = acc.find((el) => el.code === item.code);

    if (existingItem) {
      existingItem.quantity += item.quantity;
    } else {
      acc.push({ ...item });
    }

    return acc;
  }, []);

  const totalCollectorsQuantity = materialsCollectors.reduce(
    (sum, item) => sum + item.quantity,
    0
  );

  const collectorsMultiplier = totalCollectorsQuantity === 2 ? 1 : 2;

  // ortakiai
  const airDuctQuantity =
    Math.max(...materialsCollectors.map((item) => item.airDuctQuantity)) *
    collectorsMultiplier;

  const materialsAirDucts = MATERIALS_AIR_DUCTS.filter(
    (item) => item.productGroup === materialsGroup
  ).map((item) => ({
    ...item,
    quantity: airDuctQuantity * item.multiplier,
  }));

  // tarpines
  const gasketQuantity =
    Math.max(...materialsCollectors.map((item) => item.gasketQuantity)) *
    collectorsMultiplier;

  const materialsGaskets = MATERIALS_GASKETS.filter(
    (item) => item.productGroup === materialsGroup
  ).map((item) => ({
    ...item,
    quantity: gasketQuantity,
  }));

  // visi kartu
  const materialsWithoutPrices = materialsVolume
    .concat(materialsBoxes)
    .concat(materialsCollectors)
    .concat(materialsAirDucts)
    .concat(materialsGaskets);

  // Apply prices to final array
  const prices = fetchAndApplyPrices();
  const materials = prices.applyTo(materialsWithoutPrices);
  const recuperatorsWithPrices = prices.applyTo(recuperators);

  // Debug info
  console.debug('Price application:', {
    materials: {
      total: materials.length,
      with_prices: materials.filter(item => item.price !== null).length
    },
    recuperators: {
      total: recuperatorsWithPrices.length,
      with_prices: recuperatorsWithPrices.filter(item => item.price !== null).length
    }
  });

  return { recuperators: recuperatorsWithPrices, materials, totalSupply, totalExhaust };
};

const getTotal = (rows, field) => {
  return rows.reduce((total, row) => {
    const value = parseFloat(row[field]);
    return total + (isNaN(value) ? 0 : value);
  }, 0);
};
